module.exports = __webpack_public_path__ + "static/media/1274_CareTeam_bio10.926e3402.png";